import React from 'react';

import { bemBlock } from '../../modules/bem';

import { TableCellAlign } from './TableCell';
import { useTableContext } from './TableContext';

import './TableHeadCell.less';

const block = bemBlock('table-head-cell');

export type TableHeadCellProps = React.ThHTMLAttributes<HTMLTableCellElement> & {
  align?: TableCellAlign;
};

export const TableHeadCell = React.forwardRef<HTMLTableCellElement, TableHeadCellProps>(
  function TableHeadCell({ align = 'left', className, ...passProps }, ref) {
    const { shouldVirtualize } = useTableContext();

    return (
      <th
        ref={ref}
        className={block({
          modifiers: {
            align,
            virtualized: shouldVirtualize,
          },
          extra: className,
        })}
        {...passProps}
      />
    );
  },
);
